<div class="d-flex gap-2 align-items-center">
  <p-floatlabel class="flex-shrink-0" style="min-width: 140px;">
    <p-select
      [id]="'result-field-select-' + inputId"
      [options]="fields"
      optionValue="key"
      optionLabel="label"
      [(ngModel)]="selectedField"
      (onChange)="onFieldChange()"
      [showClear]="true"
      [fluid]="true"
      [filter]="fields.length > 5"
      filterBy="label"
    >
    </p-select>
    <label [for]="'result-field-select-' + inputId">{{ fieldPlaceholder | translate }}</label>
  </p-floatlabel>
  <p-floatlabel class="flex-grow-1" style="min-width: 120px;">
    <p-fluid>
      <input
        type="text"
        [id]="'result-field-value-' + inputId"
        pInputText
        [(ngModel)]="searchValue"
        (input)="onValueChange()"
        [disabled]="!selectedField"
      />
    </p-fluid>
    <label [for]="'result-field-value-' + inputId">{{ valuePlaceholder | translate }}</label>
  </p-floatlabel>
  @if (selectedField && searchValue) {
    <button
      type="button"
      class="btn btn-link p-0 text-secondary"
      (click)="clearFilter()"
      [title]="'clear' | translate"
      style="line-height: 1;"
    >
      <span class="material-symbols-outlined" style="font-size: 20px;">close</span>
    </button>
  }
</div>
